import { useEffect, useRef } from 'react';
import { Editor } from '@meitu/saas-editor-core';

/**
 * 劫持，二级功能面板打开后，点击舞台不取消激活图层
 * @returns
 */
export const useGlobalWidget = (editor: Editor, state: boolean) => {
    const visibleRef = useRef(state);
    useEffect(() => {
        const handler = editor.onMouseDown(() => {
            const hoverId = editor.services.frame.getHoverId();
            if (hoverId) {
                return false;
            }
            return visibleRef.current;
        }, 999);
        return () => {
            editor.off(handler);
        };
    }, []);

    return visibleRef;
};
